import React from 'react'
import './admin.css'
const Admin = () => {
    return (
        <div>Admin</div>
    )
}

export default Admin